import React from "react";
import PropTypes from "prop-types";
import { themr } from "react-css-themr";
import classnames from "classnames";
import { Icon, Button } from "@lifepay/rc-ui-toolkit";
// import { format } from "date-fns";

import profileSVG from "@lifepay/assets/sprites/icomoon/profile.svg";
import phonecallSVG from "@lifepay/assets/sprites/feather/communication/phone-call.svg";

import styles from "./Client.m.scss";

function Client(props) {
  const { theme, client, continueWork, onCall, endWork } = props;

  return (
    <div className={classnames(theme.wrapper)}>
      <div className={classnames(theme.inner)}>
        <div className={classnames(theme.header)}>
          <div className={classnames(theme.client)}>
            <Icon
              sprite={profileSVG}
              theme={{
                wrapper: theme["profile-icon"],
              }}
            />
            {onCall && (
              <Icon
                sprite={phonecallSVG}
                theme={{
                  wrapper: theme["call-icon"],
                }}
              />
            )}
            <div className={classnames(theme.name)}>{client.clientName}</div>
          </div>
        </div>
        <div className={classnames(theme.controls)}>
          <Button
            type={"alt"}
            size={"small"}
            onClick={() => endWork({ id: client.clientId, type: "PERSON" })}
          >
            {"Завершить"}
          </Button>
          <Button
            type={"main"}
            size={"small"}
            onClick={() =>
              continueWork({ id: client.clientId, type: "PERSON" })
            }
          >
            {"Продолжить"}
          </Button>
        </div>
      </div>
    </div>
  );
}

Client.displayName = "Client";

Client.propTypes = {
  theme: PropTypes.object,
  client: PropTypes.object.isRequired,
  onCall: PropTypes.bool,
  continueWork: PropTypes.func.isRequired,
  endWork: PropTypes.func.isRequired,
};

Client.defaultProps = {};

export default themr("@lifepay/Client", styles)(Client);



// WEBPACK FOOTER //
// ./src/components/emission/client-summary/Client/Client.js